import React from "react"

import * as styles from "./Hamburger.module.scss"

const Hamburger = (props) => {
    //const {uiSettings: {mobileMenuVisible, setMobileMenuVisible}} = useStore()

    return <div className={styles.Hamburger}>
        <button className={`${styles.hamburger} ${props.isMobileMenuVisible ? styles.isActive : ''}`} type="button" onClick={props.handleClick}>
			<span className={styles.hamburgerBox}>
				<span className={styles.hamburgerInner}></span>
			</span>
        </button>
    </div>

}

export default Hamburger